import { inject, Injectable } from '@angular/core';
import {
  AdobeDataLayerPayload,
  AdobeDataPages,
} from '../models/adobe-data-layer.model';
import { MlbStatsConnectionService } from './mlb-stats.service';
import { ConfigurationService } from './configuration.service';
import { lastValueFrom, Subject } from 'rxjs';
import { SaleEvent } from '@core/models';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProvenueErrorService {
  #pvRequestId: string;
  #pvProxyRequestId: string;

  constructor() {
    this.#pvRequestId = '';
    this.#pvProxyRequestId = '';
  }

  setPvRequestId(pvRequestId: string | null) {
    if (!pvRequestId) {
      this.#pvRequestId = '';
      return;
    }

    this.#pvRequestId = pvRequestId;
  }

  setPvProxyRequestId(pvProxyRequestId: string | null) {
    if (!pvProxyRequestId) {
      this.#pvProxyRequestId = '';
      return;
    }

    this.#pvProxyRequestId = pvProxyRequestId;
  }

  getPvRequestId() {
    return this.#pvRequestId;
  }

  getPvProxyRequestId() {
    return this.#pvProxyRequestId;
  }

  logProvenueIds() {
    console.log('pvRequestId', this.#pvRequestId);
    console.log('pvProxyRequestId', this.#pvProxyRequestId);
  }
}
